import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

import { breakpoints } from '../../../lib/constants';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1050px;
  margin: 0 auto !important;
`;

// All offset should be considered to total 100%.
// You can use a percent larger than 100% but recommended for right/left offset to be an equivelent to 100.
// Offset middle should be set more than 100%.  Ex: In a 3 column layout; offsetMiddle={150} will make the first/last columns 25%;
// Props.offsetLeft will allow you to use a percent to make the first column smaller/larger. Best used with two column
// Props.offsetRight will allow you to use a percent to make the last column smaller/larger. Best used with two column
// Props.offsetMiddle will allow you to use a percent to make the middle columns smaller or larger. Best used with three column
// Props.forceMobile will allow you to force a mobile view.
// Props.half will cut the margin right in half.
// Props.removeMarg will remove all right margins.
// Props.center will align content center from top/bottom

export const FlexContainerRow = styled.div<{
  forceMobile?: boolean;
  center?: boolean;
  flexstart?: boolean;
  half?: boolean;
  removeMarg?: boolean;
  offsetLeft?: number;
  offsetRight?: number;
  offsetMiddle?: number;
  doNotRespond?: boolean;
}>`
  display: flex;
  flex-direction: ${(props) => (props.forceMobile ? 'column' : 'row')};
  ${(props) =>
    !props.center
      ? `justify-content: ${props.flexstart ? 'flex-start' : 'space-evenly'}`
      : 'justify-content: center; align-items: center'};
  margin: 0 auto;

  > * {
    width: 100%;
    margin-right: ${(props) => (props.half ? 15 : 30)}px;
    ${(props) => (props.removeMarg ? 'margin-right: 0' : '')}
  }

  &> *:first-child {
    width: ${(props) => (props.offsetLeft != null && !props.forceMobile ? props.offsetLeft : 100)}%;
  }

  &> *:last-child{
    width: ${(props) => (props.offsetRight != null && !props.forceMobile ? props.offsetRight : 100)}%;
    margin-right: 0;
  }

  ${(props) =>
    !props.doNotRespond
      ? // use noResponse to stop the container from auto responding
        `@media (max-width: ${breakpoints.phone}px){
      display: block;
      float: none;

      > * {
        clear: left;
        float: none;
        margin-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
        width: 100%;
      }

      &> *:first-child {
        width: 100%;
      }

      &> *:last-child{
        width: 100%;
        margin-right: auto;
      }
    }`
      : ''}

  ${(props) =>
    props.offsetMiddle != null && !props.forceMobile
      ? `&> *:not(:first-child),
     &> *:not(:last-child) {
      width: ${props.offsetMiddle}%;
     }`
      : ''}
`;

export const PageWrapper = styled(Wrapper)`
  ${(props: { isHolder?: boolean }) =>
    !props.isHolder
      ? `
  margin-bottom: 50px;
  padding-top: 40px;`
      : ''}

  label {
    position: relative;
  }

  i {
    color: ${COLORS.lighterMediumDarkGray};
    font-size: 12px;
  }

  h4, h5, h6, h7, h8 {
    color: ${COLORS.darkOrange};
  }

  h1, h2, h3, h4, h5, h6, h7, h8 {
    font-weight: 300;
    line-height: 1.15em;

    + * {
      margin-top: .9rem;
    }
  }

  h2 {
    font-size: 1.4375rem;
  }

  span, p, ul, ol, li {
    margin-bottom: .9rem;
  }

  ul, ol {
    margin-left: 10px;
  }

`;

export const AppRoot = styled.div`
  padding-bottom: 20px;
  opacity: ${(props: { isFetchingData: boolean }) => (props.isFetchingData ? 0.5 : 1)};
  position: relative;
`;

export const Banner = styled.div<{ backgroundImage: string; returns?: boolean }>`
  ${(props) =>
    props.backgroundImage
      ? `
  background: url(${props.backgroundImage}) center 100% ${COLORS.lightestGray};
  `
      : `background-color: ${COLORS.darkBlue};`}
  display: flex;
  min-height: 200px;
  position: relative;

  &:before,
  &:after {
    display: table;
    width: 100%;
    clear: both;
  }

  > div {
    margin: 0 auto;
    max-width: 1050px;
    padding-left: 30px;
    padding-right: 30px;
    width: 100%;
  }

  .banner-content {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50%;
    z-index: 5;

    &.returns {
      top: 35%;
    }
  }

  img {
    bottom: 0;
    min-height: ${(props) => (props.returns ? '130' : '190')}px;
    position: absolute;
    z-index: 1;
  }

  & + div {
    padding-top: 40px;
  }

  &.thankyou {
    min-height: 130px;

    > div {
      max-width: 980px;
    }

    .banner-content {
      max-width: 50%;
      transform: translateY(-50%);

      * {
        line-height: 1.25em;
      }
    }

    &.isBundle {
      img {
        left: 55%;
      }
    }

    img {
      right: 0px;
      min-height: 120px;
    }
  }

  @media (max-width:${breakpoints.phone}px) {
    min-height: inherit;
    padding: 15px 0;
    .banner-content {
      padding-bottom: 10px;
      position: relative;
      margin-top: 0px;
      transform: translateY(0);
      top: 0;
      width: 100%;
      z-index: 5;
    }
    img {
      display: none;
    }

    &.thankyou {
      min-height: 130px;

      .banner-content {
        max-width: 100%;
        margin: 20px auto;
        transform: initial;
      }
    }
  }
`;

export const BannerTertiaryText = styled.p`
  font-weight: 400;
  margin-top: 15px;
  && {
    color: ${(props: { hasBackgroundImage: boolean }) => (props.hasBackgroundImage ? COLORS.grayBlack : COLORS.white)};
    font-size: 1.142em;
  }
`;

export const BannerMainImage = styled.img`
  && {
    bottom: ${(props: { isMrsTrustfile: boolean }) => (props.isMrsTrustfile ? '-8' : '-20')}px;
    min-height: ${(props: { isMrsTrustfile: boolean }) => (props.isMrsTrustfile ? '130' : '190')}px;
    position: absolute;
    ${(props: { isMrsTrustfile: boolean }) => (props.isMrsTrustfile ? 'left: 60%;' : '')}
    ${(props: { isBundle: boolean }) => (props.isBundle ? 'left: 55%;' : '')}
    ${(props: { isMrsTrustfile: boolean; isBundle: boolean }) => (!props.isBundle && !props.isMrsTrustfile && 'left: 50%;') || ''}
    z-index: 1;
    max-height: 260px;
    max-width: 295px;
    width: auto;
  }
`;

// All offset should be considered to total 100%.
// You can use a percent larger than 100% but recommended for right/left offset to be an equivelent to 100.
// Offset middle should be set more than 100%.  Ex: In a 3 column layout; offsetMiddle={150} will make the first/last columns 25%;
// Props.offsetLeft will allow you to use a percent to make the first column smaller/larger. Best used with two column
// Props.offsetRight will allow you to use a percent to make the last column smaller/larger. Best used with two column
// Props.offsetMiddle will allow you to use a percent to make the middle columns smaller or larger. Best used with three column
// Props.forceMobile will allow you to force a mobile view.
// Props.half will cut the margin right in half.
// Props.removeMarg will remove all right margins.
// Props.center will align content center from top/bottom

export const FlexContainerRowInner = styled(FlexContainerRow)`
  @media (max-width:${breakpoints.phone}px) {
    > * {
      padding-left: 0;
      padding-right: 0;
      margin-bottom: 0;

      flex-direction: column;
      > * {
        margin-right: 0;
      }
    }
  }
`;

export const FlexContainerRowLRPadding = styled(FlexContainerRow)`
  padding-left:30px;
  padding-right: 30px;

  @media (max-width:${breakpoints.phone}px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const NavButtons = styled.div`
     margin-top: 5px;

     p {
       margin-top: 20px;
     }

     @media (max-width:${breakpoints.phone}px) {
       margin-bottom: 40px;
     }
`;

export const FormNavButtons = styled(NavButtons)`
  margin-top: 35px;
`;

export const RelativeDiv = styled.div`
  position: relative;

  * {
    position: static;
  }

  button#submit-payment.buy-now {
    margin-bottom: 0.9375rem;
  }

  > button.tertiary.margin-left-md {
    margin-left: 20px;
  }
`;

export const ConnectorSelectorContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding-left: 30px;
  padding-right: 30px;
  > div:first-child {
    > h3 + * {
      margin-top: .357em;
    }
  }
  h2.clear {
      clear: both;
  }

  @media (max-width:${breakpoints.phone}px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export const ContentContainer = styled.div`
  margin: 0 auto;
  max-width: 1050px;
  position: relative;
  width: 100%;
  overflow: unset;

  &::before,
  &::after {
    content: "";
    display: table;
    visibility: hidden;
    width: 100%;
  }

  &.intro {
    p:last-of-type {
      margin-bottom: 25px;
    }
  }

  > div {
    width: 50%;
    float: left;
  }

  &:last-child {
    margin-bottom: 30px;
  }
`;
